import CardSectionHeader from 'components/ui/card-section-header'
import React from 'react'
import { onRupiah } from 'utils/formatCurrency'

const PembelianSelesaiBeli = ({ data }) => {
  return (
    <CardSectionHeader headerTitle={'Pembelian selesai'}>
      <div className="flex flex-col gap-3">
        <div className="sm:flex sm:gap-0 grid grid-cols-1 gap-2 justify-between items-center">
          <p className="text-md-regular text-gray-600">Pembelian selesai pada:</p>
          <p className="text-md-medium text-gray-700 text-right">
            {data?.end_time?.date} - {data?.end_time?.time}
          </p>
        </div>
        <div className="sm:flex sm:gap-0 grid grid-cols-1 gap-2 justify-between items-center">
          <p className="text-md-regular text-gray-600">Harga Pembelian</p>
          <p className="text-md-semibold text-gray-700 text-right">
            Rp. {onRupiah(data?.total_price)}
          </p>
        </div>
      </div>
    </CardSectionHeader>
  )
}

export default PembelianSelesaiBeli
